<div class="dialog-container" [@openState]="state">
  <div class="dialog">
    <div class="heading">
      <h2>Ajouter un démembrement</h2>
      <t-icon name="close" class="close" (click)="close()" title="Fermer"></t-icon>
    </div>
    <div class="content content-form">
      
      <div class="form-group">
        <label for="amount">Nombre d'actions</label>
        <input #amountInput type="text" placeholder="" [formControl]="amount" maxlength="200"/>
        <span class="info info-error" [hidden]="amount.valid || amount.pristine || !amount.errors.required">Ce champ est requis</span>
        <span class="info info-error" [hidden]="amount.valid || amount.pristine || !amount.errors.positive">Veuillez saisir un nombre positif</span>
      </div>

      <div class="form-group">
        <label>Type d'actions</label>
        <t-option [options]="movementLineShareTypeOptions" [(value)]="model.shareType"></t-option>
      </div>

      <div class="form-group">
        <label>Entité source</label>
        <t-entity-lookup [control]="sourceEntity" [hideId]="hideId"></t-entity-lookup>
      </div>

      <div class="form-group">
        <label>Entité destination</label>
        <t-entity-lookup [control]="destEntity" [hideId]="hideId"></t-entity-lookup>
      </div>

      <div class="buttons">

        <button class="btn btn-small btn-primary" [disabled]="!isValid" (click)="apply()">
          <t-icon name="check"></t-icon>
          <span class="text">Ajouter</span>
        </button>

        <button class="btn btn-small btn-gray" (click)="close()">
          <t-icon name="close"></t-icon>
          <span class="text">Annuler</span>
        </button>
      </div>
      
    </div>
  </div>
</div>